import React, { Component } from 'react'
import { checkTranslation, translate } from '../../utils/useful'
import FixedView from '../FixedView'
import IntractionActionsList from '../IntractionActionsList'
import Collapsible from 'react-collapsible'

export default class DriveViewType extends Component {

    state = {}

    componentDidMount() {
    }

    changeCollapse = () => {
        let main = this.state.main
        this.setState({ main: !main })
    }

    changeView = (item) => {

        this.props.functionsHandler('frame', 'changeView', item.key)
        this.framesOptionsList.hideView()

    }

    render() {
        return (
            <div>
                <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='flexc mrd-2'>
                    <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-bg'>
                        <div className='flexcc mrd-1'>
                            <img className={this.props.invert ? 'invert' : ''} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                        </div>
                        <p className='font-size-14 ' style={{ color: this.props.color ?? '#fff' }}>{this.props.viewType ? checkTranslation(this.props.viewType?.label) : translate('Explore')}</p>
                    </div>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.framesOptionsList = el} nodeRef={this.framesNode} xOffset={-12} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-2 shadow-3 sc-gray2 ' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                        <div className='white-bg' style={{}}>
                            {Array.isArray(this.props.driveSections) && this.props.driveSections.map((item, index) => {
                                return (
                                    <IntractionActionsList key={index} language={this.props.language} onClick={() => { this.changeView(item) }} data={{ title: item.label, icon: item.icon }} />

                                    // <IntractionActionsList language={this.props.language} onClick={() => { this.props.changeFrame(item); this.framesOptionsList.hideView() }} data={{ title: item.label, icon: item.icon }} />
                                    // <div className='flexcc w-100' onClick={() => (this.props.changeTab(item, index), this.props.changeLeftSideBarPage(item.key))}>
                                    //     <div className='w-100 cursor-pointer flexc flex-column mx-1 px-2' key={index} style={{ aspectRatio: '1 / 1', borderRadius: '10px', backgroundColor: '#fff', boxShadow: "-8px -17px 42px -20px rgba(144,144,144,0.55)" }}>
                                    //         <div className='mb-2 flexcc w-100' >
                                    //             <img src={item.icon} alt="" className="" width={40} style={{}} />
                                    //         </div>
                                    //         <div className='d-flex flex-column'>
                                    //             <p className='text-small text-bold' style={{ color: '#333' }}>{translate(item.label)}</p>
                                    //         </div>
                                    //     </div>
                                    // </div>
                                )
                            })}
                            {/* <div className='br-5' style={{ backgroundColor: '#F6F6F6', overflow: 'hidden' }}> */}
                            {/* <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}appletframe.Pin Frames", icon: "/assets/icons/applets/database/pin-purple.svg" }} /> */}
                            {/* {list?.map((prop, index) => {
                                        let name = 'form'
                                        return (
                                            <div className='bb-gray pt-2'>
                                                <button className={'flexcb p-2 w-100 hover-gray2'} style={{ backgroundColor: (prop._id == this.props.currentFrame._id ? '#E0E0EB' : '') }} onClick={() => this.changeFrame(prop)} >
                                                    <div className=' flexc'>
                                                        <p className='text-left w-100' style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", }}>{prop.name}</p>
                                                    </div>
                                                    {prop._id == this.props.currentFrame._id &&
                                                        <div className='flexcc'>
                                                            <img width={18} src='/assets/icons/check-purple.svg' />
                                                        </div>
                                                    }
                                                </button>
                                            </div>
                                        )
                                    })} */}
                            {/* </div> */}
                        </div>
                    </div>
                </FixedView >
            </div >
        )
    }
}
